(function () {

    // Bootstrap scripts
    const Bs = require("../_includes/bs.js");
    document.addEventListener("DOMContentLoaded", () => {
        let bs = new Bs();
        bs.runAll();
    });

    document.addEventListener('DOMContentLoaded', function (e) {
        document.querySelectorAll('.larativo-form-birthday').forEach(item => {
            item.addEventListener('keydown', (event) => {
                var charCode = (event.which) ? event.which : event.keyCode
                if ((charCode >= 48 && charCode <= 57) || (charCode >= 96 && charCode <= 105)) {
                    var dateBox = event.target;
                    var chars = dateBox.value.length;
                    var text = dateBox.value;

                    if (chars == 2) {
                        dateBox.value = text + ".";
                    }
                    if (chars == 5) {
                        dateBox.value = text + ".";
                    }
                }
                else if (charCode == 37 || charCode == 39 || charCode == 46 || charCode == 8) { }
                else {
                    event.preventDefault();
                }
            })
        });
    });
})();

// Close quicklinks on scroll
window.onscroll = function () {
    let isScrolled = false
    const scrollPoint = 100
    const nav = document.getElementById('quicklinks')

    function onScroll() {
        if (window.pageYOffset > scrollPoint && !isScrolled) {
            nav.classList.add("close");
            isScrolled = true
        } else if (window.pageYOffset <= scrollPoint && isScrolled) {
            nav.classList.remove("close");
            isScrolled = false
        }

        const cookieBanner = document.getElementById('cc-window');
        if (cookieBanner) {
            const display = window.getComputedStyle(cookieBanner).display;
            if (display !== 'none') {
                document.getElementsByTagName("body")[0].style.paddingBottom = cookieBanner.clientHeight + 'px';
            }
        }
    }

    onScroll()
    return onScroll
}()